import { Base } from './Base';

const classes = {
  hide: 'display-none'
};

const selectors = {
  error: '.form__error',
  input: '.form__input',
  resetPasswordFormContent: '.recover-customer-password__content'
};

export class Login extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.checkUrlHash();
    this.checkResetPasswordStatus();
    this.handleFormLinkClicks();
  }

  checkUrlHash() {
    const hash = window.location.hash;

    if (hash === '#recover') {
      this.showPasswordReset();
    }
  }

  checkResetPasswordStatus() {
    const { formResetPassword, resetPasswordSubmitted } = this.refs;

    if (formResetPassword && resetPasswordSubmitted) {
      this.showResetSuccessText();
    }
  }

  handleFormLinkClicks() {
    const { linkForgotPassword, linkCancelResetPassword } = this.refs;

    if (linkForgotPassword) {
      linkForgotPassword.addEventListener('click', (e) => {
        e.preventDefault();
        this.showPasswordReset();
        this.hideResetSuccessText();
        this.clearForms();
      });
    }

    if (linkCancelResetPassword) {
      linkCancelResetPassword.addEventListener('click', (e) => {
        e.preventDefault();
        this.hidePasswordReset();
        this.clearForms();
      });
    }
  }

  showPasswordReset() {
    const { formLogin, formResetPassword } = this.refs;

    if (formLogin && formResetPassword) {
      formLogin.classList.add(classes.hide);
      formResetPassword.classList.remove(classes.hide);
    }
  }

  hidePasswordReset() {
    const { formLogin, formResetPassword } = this.refs;

    if (formLogin && formResetPassword) {
      formLogin.classList.remove(classes.hide);
      formResetPassword.classList.add(classes.hide);
    }
  }

  showResetSuccessText() {
    const { textResetSuccess } = this.refs;

    if (textResetSuccess) {
      textResetSuccess.classList.remove(classes.hide);
    }
  }

  hideResetSuccessText() {
    const { textResetSuccess } = this.refs;

    if (textResetSuccess) {
      textResetSuccess.classList.add(classes.hide);
    }
  }

  clearForms() {
    const { formLogin, formResetPassword } = this.refs;

    if (formLogin && formResetPassword) {
      this.clearForm(formLogin);
      this.clearForm(formResetPassword);
    }
  }

  clearForm(form) {
    if (form) {
      const inputs = form.querySelectorAll(selectors.input);

      inputs.forEach((input) => {
        input.value = '';
      });

      const errors = form.querySelectorAll(selectors.error);

      errors.forEach((error) => {
        error.parentNode.removeChild(error);
      });
    }
  }
}